/* eslint-disable no-param-reassign */
import Prism from 'prismjs';
import 'prismjs/themes/prism.css';
import 'prismjs/components/prism-markup-templating';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-ruby';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-c';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-cpp';
import 'prismjs/components/prism-bash';

if (process.client) {
  const div = document.createElement('div');
  Prism.hooks.add('before-highlight', (env) => {
    let elt = env.element;
    if (!elt.hasAttribute('data-keep-tags') && elt.parentNode.tagName.toLowerCase() === 'pre') {
      elt = elt.parentNode;
    }
    let tags = elt.getAttribute('data-keep-tags');
    if (!tags) {
      return;
    }
    const placeholder = elt.getAttribute('data-keep-tags-placeholder') || '___KEEPTAGS{n}___';

    env.keepTags = true;
    env.keepTagsPlaceholder = placeholder;

    tags = tags.split(/\s*,\s*/).join('|');
    // var tags_regex = RegExp('<(' + tags + ')>([\\s\\S]*?)</\\1>', 'g');
    const tagsRegex = RegExp(`<(${tags})([^>]*)>([\\s\\S]*?)</\\1>`, 'g');

    env.keepTagsRegex = tagsRegex;

    env.tokenStack = [];
    env.backupCode = env.code;

    let code = env.element.innerHTML;
    code = code.replace(tagsRegex, (match) => {
      env.tokenStack.push(match);
      return placeholder.replace('{n}', env.tokenStack.length);
    });
    env.element.innerHTML = code;
    code = env.element.textContent;
    code = code.replace(/^(?:\r?\n|\r)/, '');

    env.code = code;
  });

  Prism.hooks.add('after-highlight', (env) => {
    if (!env.keepTags) {
      return;
    }
    // eslint-disable-next-line no-cond-assign
    for (let i = 0, t; t = env.tokenStack[i]; i += 1) {
      t = t.replace(env.keepTagsRegex, (match, tag, attributes, inside) => {
        div.innerHTML = inside;
        inside = div.textContent;
        return `<${tag}${attributes}>${Prism.highlight(inside, env.grammar, env.language)}</${tag}>`;
      });

      env.highlightedCode = env.highlightedCode.replace(env.keepTagsPlaceholder.replace('{n}', i + 1), t);
      env.element.innerHTML = env.highlightedCode;
    }
  });
}

export default Prism;
